import React,{ useState, useEffect, useRef} from "react";
import Dheader from '../../components/DHeader/dheader';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import ErrorIcon from '@mui/icons-material/Error';
import ReportIcon from '@mui/icons-material/Report';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';


const Dashboard = () => {

  const [accordianDashboard, setAccordianDashboard] = useState(false);
  const ref = useRef();

  useEffect(()=>{

    const checkIfClickedOutside = e =>{
      if(accordianDashboard && ref.current && !ref.current.contains(e.target)){
        setAccordianDashboard(false);
      }
    }
    document.addEventListener("mousedown", checkIfClickedOutside)
    return ()=>{
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  },[accordianDashboard])

  const handleOnClickMenu = (value)=>{
    sessionStorage.setItem('func', value);
  }


  return (
    <div className='dashboard-box'>
      
     <div className='dashboard-box-1 projects__container container grid'>

         <Link to={'/member'}  onClick={()=>handleOnClickMenu("member")} className='projects__card dashcard'>
        <Diversity3Icon sx={{color:"green", fontSize:"50px"}}/>
       <h2 className="projects__title"> Joined Members</h2>
         </Link>

         <Link to={'/specific/monthly'} onClick={()=>handleOnClickMenu("monthlyjoined")} className='projects__card dashcard'>
        <CalendarMonthIcon sx={{color:"purple", fontSize:"50px"}}/>
       <h2 className="projects__title"> Monthly Joined Members</h2>
         </Link>

         <Link to={'/specific/expire-with-in-3-days'}  onClick={()=>handleOnClickMenu("threeDayExpire")} className='projects__card dashcard'>
        <AccessAlarmIcon sx={{color:"red", fontSize:"50px"}}/>
       <h2 className="projects__title"> Expiring within 3 days</h2>
         </Link>

         <Link to={'/specific/expire-with-in-4-7-days'}  onClick={()=>handleOnClickMenu("fourToSevenDaysExpire")} className='projects__card dashcard'>
        <AccessAlarmIcon sx={{color:"red", fontSize:"50px"}}/>
       <h2 className="projects__title"> Expiring within 4-7 days</h2>
         </Link>

         <Link to={'/specific/expired'}  onClick={()=>handleOnClickMenu("expired")} className='projects__card dashcard'>
        <ErrorIcon sx={{color:"red", fontSize:"50px"}}/>
       <h2 className="projects__title"> Expired</h2>
         </Link>

         <Link to={'/specific/inactive-members'}  onClick={()=>handleOnClickMenu("inActiveMembers")} className='projects__card dashcard'>
        <ReportIcon sx={{color:"brown", fontSize:"50px"}}/>
       <h2 className="projects__title"> InActive Members</h2>
         </Link>

     </div>
 <Footer />
    </div>
     
  )
}

export default Dashboard
